export const racks = (state = [], action) => {
  if (action.type === 'FETCH_RACKS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_RACKS') {
    return [];
  }
  return state;
};

export const rack = (state = {}, action) => {
  if (action.type === 'FETCH_RACK') {
    return action.payload;
  }
  if (action.type === 'CLEAR_RACK') {
    return {};
  }
  return state;
};

export const rackIds = (state = [], action) => {
  if (action.type === 'FETCH_RACK_IDS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_RACK_IDS') {
    return [];
  }
  return state;
};
